import { Button, Card } from "react-bootstrap";
import React, { Component } from "react";

class PublicationCard extends Component {
  render() {
    return (
      <Card>
        <Card.Header>{this.props.header}</Card.Header>
        <Card.Body>
          <Card.Title>{this.props.title}</Card.Title>
          <Card.Text>{this.props.bodyText}</Card.Text>
          <Button variant="primary">{this.props.buttonText}</Button>
        </Card.Body>
      </Card>
    );
  }
}

export default PublicationCard;
